










































import { Component, Vue, Prop } from 'vue-property-decorator';
import { GET_PRODUCT_GROUP } from './getProductGroup';

@Component
export default class ProductGroupShow extends Vue {
  private GET_PRODUCT_GROUP = GET_PRODUCT_GROUP;
  @Prop(String) private id!: string;
}
